import { Package } from 'lucide-react';
import type { ConfigurationGroup } from '@/types/commercial/proposal-configurations';
import { StepConfigurationCard } from './step-configuration-card';

interface StepConfigurationsListProps {
  groups: ConfigurationGroup[];
  onConfigure: (groupId: string) => void;
}

export function StepConfigurationsList({ groups, onConfigure }: StepConfigurationsListProps) {
  if (groups.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <Package className="mb-4 h-12 w-12 text-muted-foreground" />
        <p className="text-sm text-muted-foreground">Nenhum grupo configurável encontrado</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {groups.map((group) => (
        <StepConfigurationCard key={group.id} group={group} onConfigure={onConfigure} />
      ))}
    </div>
  );
}
